@import '../../../node_modules/@shoelace-style/shoelace/dist/themes/light.css';

:host {
  /* Definizione delle variabili per il nostro componente */
  --jump-select-border-radius: 4px;
  --jump-select-border-color: var(--neutral-grey-disabled, #cbcbcb);
  --jump-select-border-color-hover: var(--secondary-standard, #5e79ba);
  --jump-select-border-color-focus: var(--secondary-standard, #5e79ba);
  --jump-select-background: var(--neutral-white, #ffffff);
  --jump-select-color: var(--neutral-black, #000000);
  --jump-select-font-family: var(--ff-primary, 'Inter', sans-serif);
  --jump-select-font-size: 16px;
  --jump-select-font-weight: normal;
  --jump-select-height: 40px;
  --jump-select-padding: 0 10px;
  --jump-select-disabled-opacity: 0.5;
  --jump-select-placeholder-color: var(--neutral-grey-disabled, #cbcbcb);
  --jump-select-label-margin: 0 0 8px 0;
  --jump-select-label-color: var(--neutral-black, #000000);
  --jump-select-label-font-size: 14px;
  --jump-select-label-font-weight: 500;
  --jump-select-option-selected-background: var(--secondary-standard, #5e79ba);
  --jump-select-option-selected-color: var(--neutral-white, #ffffff);
  --jump-select-dropdown-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);

  display: flex;
  flex-direction: column;
  width: 100%;

  /* Stile per l'etichetta del select */
  .select-label {
    font-family: var(--jump-select-font-family);
    font-size: var(--jump-select-label-font-size);
    font-weight: var(--jump-select-label-font-weight);
    color: var(--jump-select-label-color);
    margin: var(--jump-select-label-margin);
  }

  /* Stili diretto per Shoelace select */
  sl-select::part(form-control) {
    display: block;
    width: 100%;
  }

  sl-select::part(base) {
    width: 100%;
    font-family: var(--jump-select-font-family);
    font-size: var(--jump-select-font-size);
    font-weight: var(--jump-select-font-weight);
  }

  sl-select::part(control) {
    height: var(--jump-select-height);
    border-radius: var(--jump-select-border-radius);
    border-color: var(--jump-select-border-color);
    background-color: var(--jump-select-background);
    color: var(--jump-select-color);
    padding: var(--jump-select-padding);
  }

  sl-select::part(control):hover {
    border-color: var(--jump-select-border-color-hover);
  }

  sl-select::part(control):focus-within {
    border-color: var(--jump-select-border-color-focus);
    box-shadow: 0 0 0 2px rgba(94, 121, 186, 0.25);
  }

  sl-select::part(display-input) {
    height: var(--jump-select-height);
    line-height: var(--jump-select-height);
    color: var(--jump-select-color);
  }

  sl-select::part(placeholder) {
    color: var(--jump-select-placeholder-color);
  }

  sl-select::part(dropdown) {
    box-shadow: var(--jump-select-dropdown-box-shadow);
    border-radius: var(--jump-select-border-radius);
    z-index: 100;
  }

  sl-select::part(listbox) {
    font-family: var(--jump-select-font-family);
    font-size: var(--jump-select-font-size);
  }

  sl-select::part(tags) {
    margin-top: 0;
  }

  sl-select::part(tag) {
    background-color: var(--secondary-standard, #5e79ba);
    color: var(--neutral-white, #ffffff);
  }

  sl-select[disabled]::part(control) {
    opacity: var(--jump-select-disabled-opacity);
    cursor: not-allowed;
  }

  /* Stili per le opzioni */
  sl-option::part(checked-icon) {
    color: var(--jump-select-option-selected-color);
  }

  sl-option[selected]::part(base) {
    background-color: var(--jump-select-option-selected-background);
    color: var(--jump-select-option-selected-color);
  }
}
